import type { ApiError } from "../../api/client";

/** errorMessage returns the server's client-safe message (ARC-08) or a fallback. */
export function errorMessage(error: unknown, fallback: string): string {
  const e = (error as { error?: ApiError } | undefined)?.error;
  return e?.message ?? fallback;
}

export function errorCode(error: unknown): string | undefined {
  return (error as { error?: ApiError } | undefined)?.error?.code;
}

/**
 * unwrap turns an openapi-fetch result into its data, throwing the error body
 * otherwise so react-query exposes it (read it with errorMessage).
 */
export async function unwrap<T>(p: Promise<{ data?: T; error?: unknown }>): Promise<T> {
  const { data, error } = await p;
  if (data === undefined) throw error ?? {};
  return data;
}

/** retryable says whether a failed query is worth one more attempt (network or server errors only). */
export function retryable(error: unknown): boolean {
  const code = errorCode(error);
  return code === undefined || code === "unavailable" || code === "internal";
}
